/**
 * Полноэкранный просмотр фотографии.
 * Закрывается по клику на фон или на крестик.
 * 
 * Пропсы:
 *   src — url фотографии
 *   onClose — функция закрытия
 * 
 * Применяется: InProgressOrderView, CompletedOrderView, Diagnostic
 */

export default function PhotoPreviewOverlay({ src, onClose }) {
    if (!src) return null

    return (
        <div
            onClick={onClose}
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.9)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
        >
            <img
                src={src}
                alt="предпросмотр"
                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '8px' }}
            />
            <button
                onClick={onClose}
                style={{ position: 'absolute', top: '20px', right: '20px', background: 'white', border: 'none', borderRadius: '50%', width: '36px', height: '36px', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
                ×
            </button>
        </div>
    )
}